import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { MdArrowBack, MdInfoOutline, MdPeopleOutline, MdSchedule, MdAttachMoney, MdFilterNone, MdLocationOn, MdInbox,
   MdTrendingUp, MdMessage, MdAccountBalance, MdDescription, MdAssignment } from 'react-icons/lib/md';

const Sidebar = ({ backUrl, divisionName, permissions }) => {

    const { roleModules } = permissions.editPrivileges;
 
    var hasPiaRole = false;
    if ( roleModules ) {
        hasPiaRole = roleModules.includes('PIA')
    }

    return (
  <div className="App-sidebar no-print">
      <ul>
      <li><Link to="/search"><span className="fa-Icon-MT-Emblem"/></Link></li>
      <li><Link to={backUrl}><span><MdArrowBack className = "fa-Icon" /></span></Link></li>
      <li className="nav-icons-visibility"><a href="#info"><span><MdInfoOutline className = "fa-Icon" /></span></a></li>
      <li className="nav-icons-visibility"><a href="#clientAgency"><span><MdAccountBalance className = "fa-Icon" /></span></a></li>
      <li className="nav-icons-visibility"><a href="#fieldInfo"><span><MdDescription className = "fa-Icon" /></span></a></li>
      <li className="nav-icons-visibility"><a href="#team"><span><MdPeopleOutline className = "fa-Icon" /></span></a></li>
      <li className="nav-icons-visibility"><a href="#schedule"><span><MdSchedule className = "fa-Icon" /></span></a></li>
      <li className="nav-icons-visibility"><a href="#budget"><span><MdAttachMoney className = "fa-Icon" /></span></a></li>
      <li className="nav-icons-visibility"><a href="#documents"><span><MdFilterNone className = "fa-Icon" /></span></a></li>
      <li className="nav-icons-visibility"><a href="#locations"><span><MdLocationOn className = "fa-Icon" /></span></a></li>
      <li className="nav-icons-visibility"><a href="#delay-logs"><span><MdInbox className = "fa-Icon" /></span></a></li>
      <li className="nav-icons-visibility"><a href="#progress-reports"><span><MdTrendingUp className = "fa-Icon" /></span></a></li>
      <li className="nav-icons-visibility"><a href="#comments"><span><MdMessage className = "fa-Icon" /></span></a></li>
      {hasPiaRole ?
        <li className="nav-icons-visibility"><a href="#pia"><span><MdAssignment className = "fa-Icon" /></span></a></li>
      : null}
      <li className="nav-icons-visibility">
        <a href="#timestamp">
            <span>
            <svg fill="currentColor" preserveAspectRatio="xMidYMid meet" height="1em" width="1em" viewBox="0 0 640 512" className="fa-Icon" style={{verticalAlign: "middle"}} xmlns="http://www.w3.org/2000/svg"><path d="M496 224c-79.6 0-144 64.4-144 144s64.4 144 144 144 144-64.4 144-144-64.4-144-144-144zm64 150.3c0 5.3-4.4 9.7-9.7 9.7h-60.6c-5.3 0-9.7-4.4-9.7-9.7v-76.6c0-5.3 4.4-9.7 9.7-9.7h12.6c5.3 0 9.7 4.4 9.7 9.7V352h38.3c5.3 0 9.7 4.4 9.7 9.7v12.6zM320 368c0-27.8 6.7-54.1 18.2-77.5-8-1.5-16.2-2.5-24.6-2.5h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h347.1c-45.3-31.9-75.1-84.5-75.1-144zm-96-112c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128z"/></svg>
            </span>
        </a>
    </li>
    </ul>
    </div>
    )
}


Sidebar.propTypes = {
    backUrl: PropTypes.string.isRequired
}

export default Sidebar;
